import styled from 'styled-components';

export const ContainerTitle = styled.h2`
  font-weight: 400;
  font-size: 96px;

  color: white; 

  text-align: center;
  position: relative;

  margin: 20% 0 auto;

      
    @media only screen and (max-device-width: 900px) {
      font-size: 24px;
      width:100%;
      margin-top: 60%;
    }
`;

export const ContainerLink = styled.div`

  position: relative;

  .icon:focus, a:hover{
      opacity: .5;
    }

  @media (max-width: 800px) {
    width: 100%;
    .icon img{
      width: 15px;
      height: 15px;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    
  }
 `;  


export const Container = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;

   @media only screen and (max-device-width: 800px){
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
